import ExpandAllButton, {
  EXPAND_MODE_EXPANDED,
  EXPAND_MODE_COLLAPSED,
} from '../../common/components/List/ExpandAllButton.js'
import {
  setExpandedReferenceIDs,
  setExpandMode,
  expandModeSelector,
  expandedReferenceIDsSelector,
} from './stocktakeListFunctions.js'
import {useSelector} from '../../store.js'

export default function StocktakeExpandAll() {
  const expandMode = useSelector(expandModeSelector)
  const expandedMOCount = useSelector(expandedReferenceIDsSelector).length

  const shouldCollapse =
    expandedMOCount > 1 || expandMode === EXPAND_MODE_EXPANDED

  return (
    <li
      className="inline-block margin-right-3 tooltip--top"
      data-hint={
        shouldCollapse ? 'Collapse all Stocktakes' : 'Expand all Stocktakes'
      }
    >
      <ExpandAllButton
        className="meta-stocktakelistheader-button-expandall"
        shouldCollapse={shouldCollapse}
        onExpandAll={() => {
          setExpandedReferenceIDs([])
          setExpandMode(EXPAND_MODE_EXPANDED)
        }}
        onCollapseAll={() => {
          setExpandedReferenceIDs([])
          setExpandMode(EXPAND_MODE_COLLAPSED)
        }}
      />
    </li>
  )
}
